import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { toast } from "sonner";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { useAuth, roleHome } from "../lib/auth";
import { api, apiError, tokenStore } from "../lib/api";
import AppLogo from "../components/AppLogo";

export default function SignupPatient() {
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ full_name: "", email: "", password: "", phone: "" });
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError("");
    try {
      const { data } = await api.post("/auth/signup/patient", form);
      tokenStore.set(data.access_token);
      setUser(data.user);
      toast.success("Account created");
      navigate(roleHome(data.user.role), { replace: true });
    } catch (err) {
      setError(apiError(err, "Signup failed"));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-mb-bg text-white flex flex-col">
      <header className="px-6 lg:px-12 py-5 border-b border-mb-border">
       <AppLogo
  to="/"
  subtitle="Smart Clinic • Easy Care"
  size={48}
/>
      </header>
      <main className="flex-1 flex items-center justify-center px-6 py-12">
        <div className="w-full max-w-md" data-testid="signup-patient-card">
          <h1 className="text-3xl tracking-tight font-light">Create patient account</h1>
          <p className="mt-2 text-sm text-mb-fg2">Find doctors and book in minutes (full booking ships in Phase 3).</p>

          <form onSubmit={onSubmit} className="mt-8 space-y-5">
            <Field id="full_name" label="Full name" value={form.full_name} onChange={update("full_name")} required testid="patient-fullname" />
            <Field id="email" type="email" label="Email" value={form.email} onChange={update("email")} required testid="patient-email" />
            <Field id="phone" label="Phone" value={form.phone} onChange={update("phone")} testid="patient-phone" />
            <Field id="password" type="password" label="Password" value={form.password} onChange={update("password")} required testid="patient-password" />
            {error && <div data-testid="signup-patient-error" className="text-sm text-red-400 bg-red-500/10 border border-red-500/20 rounded-lg p-3">{error}</div>}
            <Button type="submit" disabled={submitting} data-testid="signup-patient-submit"
              className="w-full h-11 bg-teal-500 hover:bg-teal-400 text-zinc-950 rounded-lg font-medium">
              {submitting ? "Creating…" : "Create account"}
            </Button>
          </form>
          <div className="mt-6 text-sm text-mb-fg2">Already have an account? <Link to="/login" className="text-teal-400 hover:text-teal-300">Sign in</Link></div>
        </div>
      </main>
      <footer className="border-t border-mb-border px-6 py-5 text-center text-xs text-mb-fg2">
  <div>© 2026 MediBooks</div>
  <div className="mt-1">A Product of MNV Solutions</div>
</footer>
    </div>
  );
}



function Field({ id, label, type = "text", value, onChange, required, testid }) {
  return (
    <div className="space-y-2">
      <Label htmlFor={id} className="text-xs uppercase tracking-[0.2em] text-mb-fg2">{label}</Label>
      <Input id={id} type={type} value={value} onChange={onChange} required={required}
        data-testid={testid}
        className="bg-mb-surface2 border-mb-border text-white h-11 rounded-lg focus-visible:ring-teal-500" />
    </div>
    
    
  );
}
